import { MONTHS } from '@/shared/utils/dateHelpers';
import { fmtAUD } from '@/shared/utils/formatCurrency';
import { S } from '@/shared/constants/styles';

export default function BudgetCopyPanel({
  selMonth, selYear,
  expenseMap, budgets, currentBudgets,
  availableBudgetMonths, categoryMonths,
  copySource, setCopySource,
  copyMode, setCopyMode,
  copyCategory, setCopyCategory,
  deleteConfirm, setDeleteConfirm,
  copyBudgetFrom, currency,
}) {
  return (
    <div style={{ ...S.card, padding: 20, marginBottom: 16, background: "#f0f9ff", border: "1px solid #bae6fd" }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#0369a1", marginBottom: 14 }}>{"Copy budget into " + MONTHS[selMonth] + " " + selYear}</div>
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        <button onClick={() => { setCopyMode("entire"); setCopySource(""); setCopyCategory(""); }} style={{ ...S.btnSm(copyMode === "entire" ? "#0369a1" : "#e0f2fe"), color: copyMode === "entire" ? "white" : "#0369a1", borderRadius: 20, padding: "6px 16px" }}>Entire budget</button>
        <button onClick={() => { setCopyMode("category"); setCopySource(""); }} style={{ ...S.btnSm(copyMode === "category" ? "#0369a1" : "#e0f2fe"), color: copyMode === "category" ? "white" : "#0369a1", borderRadius: 20, padding: "6px 16px" }}>Single category</button>
      </div>

      {copyMode === "entire" && (
        <>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <select value={copySource} onChange={e => setCopySource(e.target.value)} style={{ ...S.select, width: "auto", minWidth: 180, fontSize: 13 }}>
              <option value="">Select source month...</option>
              {availableBudgetMonths.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
            </select>
            {copySource && deleteConfirm !== "copyBudget" && (
              <button onClick={() => { if (Object.keys(currentBudgets).length > 0) { setDeleteConfirm("copyBudget"); } else { copyBudgetFrom(copySource); } }} style={S.btnSm(Object.keys(currentBudgets).length > 0 ? "#f59e0b" : "#10b981")}>
                {Object.keys(currentBudgets).length > 0 ? "Overwrite" : "Copy"}
              </button>
            )}
            {deleteConfirm === "copyBudget" && (
              <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fef3c7", borderRadius: 8, padding: "8px 12px" }}>
                <span style={{ fontSize: 12, color: "#92400e" }}>Replace all {MONTHS[selMonth]} budgets?</span>
                <button onClick={() => { copyBudgetFrom(copySource); setDeleteConfirm(null); }} style={S.btnSm("#ef4444")}>Yes</button>
                <button onClick={() => setDeleteConfirm(null)} style={{ ...S.btnSm("#e2e8f0"), color: "#475569" }}>No</button>
              </div>
            )}
          </div>
          {copySource && budgets[copySource] && (
            <div style={{ marginTop: 12, fontSize: 12, color: "#64748b", lineHeight: 1.7 }}>
              {"Preview: " + Object.entries(budgets[copySource]).filter(([, v]) => Number(v) > 0).map(([k, v]) => k + ": " + currency + fmtAUD(v)).join(", ")}
            </div>
          )}
        </>
      )}

      {copyMode === "category" && (
        <>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: copyCategory && categoryMonths.length > 0 ? 10 : 0 }}>
            <select value={copyCategory} onChange={e => { setCopyCategory(e.target.value); setCopySource(""); setDeleteConfirm(null); }} style={{ ...S.select, width: "auto", minWidth: 180, fontSize: 13 }}>
              <option value="">Select category group...</option>
              {Object.keys(expenseMap).filter(g => availableBudgetMonths.some(m => (expenseMap[g] || []).some(cat => Number((budgets[m.key] || {})[cat]) > 0))).map(g => <option key={g} value={g}>{g}</option>)}
            </select>
            {copyCategory && categoryMonths.length > 0 && (
              <select value={copySource} onChange={e => setCopySource(e.target.value)} style={{ ...S.select, width: "auto", minWidth: 180, fontSize: 13 }}>
                <option value="">Select source month...</option>
                {categoryMonths.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
              </select>
            )}
            {copyCategory && categoryMonths.length === 0 && (
              <span style={{ fontSize: 12, color: "#94a3b8", fontStyle: "italic" }}>No months have budgets for {copyCategory}</span>
            )}
            {copySource && copyCategory && deleteConfirm !== "copyCat" && (
              <button onClick={() => { const items = expenseMap[copyCategory] || []; const hasExisting = items.some(c => Number(currentBudgets[c]) > 0); if (hasExisting) { setDeleteConfirm("copyCat"); } else { copyBudgetFrom(copySource); } }} style={S.btnSm((() => { const items = expenseMap[copyCategory] || []; return items.some(c => Number(currentBudgets[c]) > 0) ? "#f59e0b" : "#10b981"; })())}>
                {(() => { const items = expenseMap[copyCategory] || []; return items.some(c => Number(currentBudgets[c]) > 0) ? "Overwrite" : "Copy"; })()}
              </button>
            )}
            {deleteConfirm === "copyCat" && (
              <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fef3c7", borderRadius: 8, padding: "8px 12px" }}>
                <span style={{ fontSize: 12, color: "#92400e" }}>Replace {copyCategory} budgets?</span>
                <button onClick={() => { copyBudgetFrom(copySource); setDeleteConfirm(null); }} style={S.btnSm("#ef4444")}>Yes</button>
                <button onClick={() => setDeleteConfirm(null)} style={{ ...S.btnSm("#e2e8f0"), color: "#475569" }}>No</button>
              </div>
            )}
          </div>
          {copySource && copyCategory && budgets[copySource] && (
            <div style={{ marginTop: 12, fontSize: 12, color: "#64748b", lineHeight: 1.7 }}>
              {"Preview: " + ((expenseMap[copyCategory] || []).filter(cat => Number((budgets[copySource] || {})[cat]) > 0).map(cat => cat + ": " + currency + fmtAUD((budgets[copySource] || {})[cat])).join(", ") || (copyCategory + " has no values in this month"))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
